export default {
  hello: 'Default Page',
  name: 'name',
  email: 'email',
  submit: 'Save',
}
